// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"665":"62551470","675":"6d4ce4c4","717":"fe03571b","867":"97db7080"}[chunkId] + ".chunk.js";
};